import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import { MONO } from "../constants"

export function NoLinkScreen() {
  return (
    <Box sx={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center",
      alignItems: "center", p: 3, gap: 1.5 }}>
      <Typography sx={{ color: "rgba(var(--app-fg-rgb),0.45)", fontFamily: MONO, fontSize: "0.75rem",
        textAlign: "center", lineHeight: 1.7 }}>
        Link your account to a local<br />server user to join the chat.
      </Typography>
      <Typography sx={{ color: "rgba(var(--app-fg-rgb),0.22)", fontFamily: MONO, fontSize: "0.65rem", textAlign: "center" }}>
        Settings → SSH → Account Link
      </Typography>
    </Box>
  )
}
